import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { actionStyles } from "@dana/Overrides/Widgets/MyListsDetails/MyListsDetailsActions";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

actionStyles.iconContainer = mergeToNew(actionStyles.iconContainer, {
    css: css`
        margin-top: 5px;
        @media print {
            display: none;
        }
    `,
});

actionStyles.buttonWrapper = mergeToNew(actionStyles.buttonWrapper, {
    css: css`
        @media print {
            display: none;
        }
    `,
});

actionStyles.nameText = mergeToNew(actionStyles.nameText, {
    css: css`
        @media print {
            margin: 0;
            font-size: ${fontSizes.large} !important;
            line-height: ${lineHeights.large};
        }
    `,
});

actionStyles.addTagsButton = mergeToNew(actionStyles.addTagsButton, {
    css: css`
        padding: 8px 24px;
    `,
});

actionStyles.shareButton = mergeToNew(actionStyles.shareButton, {
    css: css`
        padding: 8px 24px;
    `,
});

actionStyles.addListButton = mergeToNew(actionStyles.addListButton, {
    css: css`
        padding: 8px 24px;
    `,
});

actionStyles.overflowMenu = mergeToNew(actionStyles.overflowMenu, {
    buttonProps: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            &:hover {
                background: transparent;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-top: -7px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    mergeCss: true,
    cssOverrides: {
        menuItem: css`
            &:hover {
                background: ${themeColors.primary.danaBlue};
                color: ${themeColors.primary.white};
            }
        `,
    },
});

actionStyles.scheduleReminderModal = mergeToNew(actionStyles.scheduleReminderModal, {
    modal: {
        size: 800,
        sizeVariant: "large",
    },
});


actionStyles.centeringWrapper = mergeToNew(actionStyles.centeringWrapper, {
    css: css`
        height: 42px;
        svg {
            width: 24px;
            height: 24px;
        }
    `
});